export default __webpack_public_path__ + "static/media/show-oil-1.b960b636.webp";